import './home.scss'
import {Fragment} from "react";
import {Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

export interface ChartData {
  name: string,
  updates: number
}

export interface ChartTileProps {
  title: string,
  subtitle: string,
  dateRange: string,
  chartData: ChartData[]
}

export const ChartTile: React.FC<ChartTileProps> = ({
                                                      title,
                                                      subtitle,
                                                      dateRange,
                                                      chartData
                                                    }) => {
  return (
      <Fragment>
        <div className="home__card-container">
          <p className="home__card-title ln-u-color-orange">{title}</p>

          <p className="home__card-subtitle ln-u-color-grey ln-u-font-family-base">{subtitle}</p>
        </div>
        <ResponsiveContainer width="100%" height="60%">
          <AreaChart data={chartData}
                     margin={{top: 0, right: 20, left: -30, bottom: -10}}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#F06C00" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#FFFFFF" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis axisLine={false} tickLine={false} dataKey="name"/>
            <YAxis axisLine={false} tickLine={false}/>
            <Tooltip labelFormatter={() => " "}/>
            <Area type="monotone" dataKey="updates" stroke="#F06C00" fillOpacity={1}
                  fill="url(#colorUv)"/>
          </AreaChart>
        </ResponsiveContainer>
        <div className="ln-u-text-align-center">
          <p className="home__card-subtitle ln-u-color-grey ln-u-font-family-base ln-u-padding-top">{dateRange}</p>
        </div>
      </Fragment>
  )
}
